module.exports = __webpack_public_path__ + "5862167761179ac427852197eeee952c.jpg";